// Horodatage des événements audio.
//
// Le worklet fournit, pour chaque paquet, l'instant audio (AudioContext.currentTime) de son
// premier échantillon. Le fil principal lit l'horloge audio à la réception du paquet : la
// différence est le temps écoulé depuis la capture du paquet, que l'on retranche à
// performance.now() pour dater le premier échantillon sur l'horloge commune.
//
// Le détecteur date ensuite chaque attaque à sa position dans le flux d'échantillons : le
// délai de traitement de la détection (le temps de reconnaître la hauteur) n'entre donc
// jamais dans l'horodatage. La compensation de latence ne doit couvrir que la latence
// d'entrée de l'appareil (micro, pilote, tampons du navigateur), pas ce délai.

/** Instant (ms, horloge performance.now) du premier échantillon d'un paquet audio. */
export function audioBlockPerfTime(perfNowMs: number, audioNowSec: number, blockStartSec: number): number {
  return perfNowMs - (audioNowSec - blockStartSec) * 1000;
}

/** Applique la compensation de latence d'entrée à l'instant d'une attaque. */
export function compensateLatency(attackTimeMs: number, latencyMs: number): number {
  return attackTimeMs - Math.max(0, latencyMs);
}
